/**
 * @desc 交易中心分页查询
 */
import {
  PageTradeSessionMallPageItem,
  TradeSessionMallPageParam
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryTradeSessionMallPageParameter = TradeSessionMallPageParam

const method = 'GET'
const url = '/trade/tradeSession/mall/page'

export const queryTradeSessionMallPageApi = (
  params?: QueryTradeSessionMallPageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageTradeSessionMallPageItem>({
    method,
    url,
    params,
    ...config
  })
}

queryTradeSessionMallPageApi.method = method
queryTradeSessionMallPageApi.url = url
